//@ flow
const showConfirmationDialog = () => {
    window.dispatchEvent(
        new CustomEvent('confirmationDialogDisplayed', {
            detail: {
                payload: 'Confirmation Dialog displayed successfully',
                stopLoading: true,
                type: 'success'
            }
        })
    );
    return;
}

export default showConfirmationDialog;
